var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PayoutBalanceComponent',{attrs:{"title":"SPs Balance Outstanding","balanceType":"outstanding"}})
}
var staticRenderFns = []

export { render, staticRenderFns }